import http from '../http-common';
import authHeader from './auth-header';
const API_URL = '/api/';

class CompetitionDataService {
  getAll() {
    return http.get(API_URL + "competitions", { headers: authHeader() });
  }

  getAllCallroom() {
    return http.get(API_URL + "callroomCompetitions", { headers: authHeader() });
  }

  findCompetitionsActive() {
    return http.get(API_URL + "findCompetitionsActive", { headers: authHeader() });
  }

  get(id) {
    return http.get(API_URL + `competition/${id}`, { headers: authHeader() });
  }

  getFull(id) {
    return http.get(API_URL + `competitionFull/${id}`, { headers: authHeader() });
  }

  create(data) {
    return http.post("/api/competition", data, { headers: authHeader() });
  }

  update(id, data) {
    return http.put(`/api/competition/${id}`, data, { headers: authHeader() });
  }

  delete(id) {
    return http.delete(`/api/competition/${id}`, { headers: authHeader() });
  }

  getOTCompetitions() {
    return http.get(`/api/otCompetitions`, { headers: authHeader() });
  }
  
  importOT(url) {
    return http.post(`/api/importOT`, { url }, { headers: authHeader() });  
  }

  checkStatus(taskId) {
    return http.get(`/api/status/${taskId}`, { headers: authHeader() });
  }

  getCompetitions() {
    return http.get(`/api/competitions`, { headers: authHeader() });
  }

  // deleteAll() {
  //   return http.delete(`/api/competitions`);
  // }

  // findByTitle(title) {
  //   return http.get(`/api/competitions?title=${title}`);
  // }

  getEmailText(competition_id) {
    return http.get(`/api/competition/${competition_id}/getEmailText`, { headers: authHeader() }); 
  }

  sendTestEmail(competition_id, testEmail) {
    return http.post(`/api/competition/${competition_id}/sendTestEmail`, { testEmail }, { headers: authHeader() });
  }

  getCompetitionFile({ url, label }) {
    http.get(url, { responseType: 'blob', headers: authHeader() })
    .then(response => {
      const blob = new Blob([response.data], { type: 'application/json' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = label
      link.click()
      URL.revokeObjectURL(link.href)
    }).catch(console.error);
  }

  competitionActivation(id) {
    return http
      .post(`/api/competition/${id}/activation`, id, { headers: authHeader() })
      .then(response => {
        console.log(response.data);
        if (response.data.message === "Competition already activated") {
          window.location.href = `/competition/${id}/activation`;
          return;
        }
        // Redirect to response.data.data.redirectUrl
        // If response.data.data.redirectUrl is not set, then check response.data.redirectUrl, then go to /competition/{id}
        if (response.data.data.redirectUrl == undefined) {
          if (response.data.redirectUrl == undefined) {
            window.location.href = `/competition/${id}`;
          } else {
            window.location.href = response.data.redirectUrl;
          }
        }
        window.location.href = response.data.data.redirectUrl;
        
        // return response.data;
      })
      .catch(e => {
        console.log(e);
      });
  }

  competitionActivationStatus(id) {
    return http
      .post(`/api/competition/${id}/activationUpdateStatus`, id, { headers: authHeader() })
      .then(response => {
        console.log(response.data);
        return response.data;
      })
      .catch(e => {
        console.log(e);
      });
  }

  verifyCompetitionTestEmailCode(competition_id, code) {
    return http
      .get(`/api/competition/${competition_id}/mail/verifyCompetitionTestEmailCode/${code}`, { headers: authHeader() })
      .then(response => {
        // console.log("verifyCompetitionTestEmailCode response.data");
        // console.log(response.data);
        return response.data;
      })
      .catch(e => {
        console.log(e);
      });
  }

  getCompetitionEmailSendActive(competition_id) {
    return http
      .get(`/api/competition/${competition_id}/emailsendactive`, { headers: authHeader() })
      .then(response => {
        // console.log("updateCompetitionEmailSendActive response.data");
        // console.log(response.data);
        return response.data;
      })
      .catch(e => {
        console.log(e);
      });
  }

  getCompetitionParticipantsWithEmail(competition_id) {
    return http
      .get(`/api/competition/${competition_id}/participantswithemails`, { headers: authHeader() })
      .then(response => {
        // console.log("updateParticipants response.data");
        // console.log(response.data);
        return response.data;
      })
      .catch(e => {
        console.log(e);
      });
  }

  sendEmails(competition_id, active) {
    return http
      .post(`/api/competition/${competition_id}/emailsendactive`, { emailsendactive: active }, { headers: authHeader() })
      .then(response => {
        console.log("sendEmails response.data");
        console.log(response.data);
        return response.data;
      })
      .catch(e => {
        console.log(e);
      });
  }

  sendParticipantEmail(competition_id, participant_id, manual_email) {
    return http
      .post(`/api/competition/${competition_id}/participant/${participant_id}/sendemail`, { manual_email }, { headers: authHeader() })
      .then(response => {
        console.log("sendParticipantEmail response.data");
        console.log(response.data);
        return response.data;
      })
      .catch(e => {
        console.log(e);
      });
  }

}

export default new CompetitionDataService();

